import React from 'react'
import { IonCol, IonGrid, IonItemDivider, IonLabel, IonRow } from '@ionic/react'
import NumberPad, { INumberPadProps } from '../numberPad/NumberPad.component'
import SInput, { IStringInput } from '../stringInput/StringInput.component'
import MultiSelect, { IMultiSelectProps } from '../multiSelect/MultiSelect.component'
import SingleSelect, { ISingleSelectProps } from '../singleSelect/SingleSelect.component'
import TimesRow, { ITimesRowProps } from '../../features/times/timesRow/TimesRow.component'
import Toggle, { IToggle } from '../toggle/Toggle.component'
import TextArea, { ITextArea } from '../textArea/TextArea.component'
import DateTimePicker, { IDateTimePickerProps } from '../calendar/DateTimePicker/DateTimePicker.component'

const Components = {
  numberPad: NumberPad,
  text: SInput,
  textArea: TextArea,
  multiSelect: MultiSelect,
  singleSelect: SingleSelect,
  timesRow: TimesRow,
  toggle: Toggle,
  date: DateTimePicker,
}

export const INPUT_TYPES = {
  NUMBER_PAD: 'numberPad',
  TEXT: 'text',
  MULTI_SELECT: 'multiSelect',
  SINGLE_SELECT: 'singleSelect',
  TIMES_ROW: 'timesRow',
  TOGGLE: 'toggle',
  SEPARATOR: 'separator',
} as const

type InputType = typeof INPUT_TYPES[keyof typeof INPUT_TYPES]

export interface IInputRow {
  key: string
  inputs: Array<IDynamicInput>
}

interface ISeparatorProps {
  heading: string
}

export interface IDynamicInput {
  key: string
  type: InputType
  hidden: boolean
  dataModelMapping?: string
  fieldNumber?: string
  props:
    | INumberPadProps
    | ISingleSelectProps
    | ITimesRowProps
    | IMultiSelectProps
    | IStringInput
    | IToggle
    | ISeparatorProps
    | ITextArea
    | IDateTimePickerProps
}

export interface IDynamicProcedure {
  inputRows: Array<IInputRow>
}

const ProcedureDynamicComponent: React.FC<IDynamicProcedure> = (props: IDynamicProcedure) => {
  const { inputRows } = props

  const isSeparatorProps = (props: any): props is ISeparatorProps => {
    return 'heading' in props
  }

  return (
    <>
      <IonGrid class='procedure-grid ion-no-padding'>
        {inputRows.map(function (row) {
          const hiddenInputs = row.inputs.filter((input) => input.hidden === true).length
          return (
            <>
              <IonRow key={row.key}>
                {row.inputs.map(function (input) {
                  if (!input.hidden) {
                    return input.type === INPUT_TYPES.SEPARATOR ? (
                      <IonItemDivider color='light' className='ion-padding'>
                        <IonLabel className='grid-item-divider-label' color='medium'>
                          {isSeparatorProps(input.props) && input.props.heading}
                        </IonLabel>
                      </IonItemDivider>
                    ) : (
                      <IonCol key={input.key}>
                        {
                          // @ts-ignore
                          React.createElement(Components[input.type], { ...input.props })
                        }
                      </IonCol>
                    )
                  }
                })}
              </IonRow>
              {hiddenInputs !== row.inputs.length && <hr className='field-divider' />}
            </>
          )
        })}
      </IonGrid>

      <IonItemDivider color='light' />
    </>
  )
}

export default ProcedureDynamicComponent
